/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import _ from "lodash";
import { MaterialReactTable, MRT_ActionMenuItem } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import Icon from "@mui/material/Icon";
import Box from "@mui/material/Box";
import Loading from "components/loading";
import MDTypography from "components/MDTypography";
import { Badge, Button, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { ObtenerDocumentosCita } from "store/tav/tavActions";
import { updateLoadingDescarga } from "store/tav/tavSlice";
import { useDispatch, useSelector } from "react-redux";
import { descargarDocumetacionGeneral } from "store/download/dowloadActions";
import DescargarArchivo from "../../DescargaArchivos";
import { useState } from "react";
import toast from "react-hot-toast";
import moment from "moment-timezone";
import { store } from "store/store";

const Example = ({
  columns,
  data,
  tablaProx,
  onCargarDoc,
  EliminarCita,
  NotificarPaciente,
  NotificarMedico,
  esExpediente,
}) => {
  const { progress, loading } = useSelector((state) => state.download);

  const dispatch = useDispatch();

  const [descargandoId, setDescargandoId] = useState(null);

  const DownloadArchivo = async (ruta, id) => {
    if (!loading && !descargandoId) {
      dispatch(updateLoadingDescarga({ tabla: "citas", idDocumentoCita: id, valor: true }));
      setDescargandoId(id);
      await dispatch(descargarDocumetacionGeneral(ruta));
      dispatch(updateLoadingDescarga({ tabla: "citas", idDocumentoCita: id, valor: false }));
      setDescargandoId(null);
    } else {
      toast.error("Solo es posible descargar un archivo a la vez, por favor a espera!!!");
    }
  };
  const usuarioPermisos = store.getState().login?.usuario?.permisos;
  const agregareliminarCita = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (esExpediente == 1 ? 77 : 30)
  );
  const notificarpacientemedico = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (esExpediente == 1 ? 78 : 31)
  );

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      localization={MRT_Localization_ES}
      autoResetPageIndex={false}
      initialState={{
        density: "compact",
        columnPinning: {
          left: ["mrt-row-expand", "mrt-row-select"],
          right: ["mrt-row-actions"],
        },
      }}
      paginationDisplayMode="pages"
      muiPaginationProps={{
        sx: {
          // Estilo general del componente de paginación
          "& .MuiPaginationItem-root": {
            color: "#FFFFFF", // Color de todos los números de página
          },
          "& .Mui-selected": {
            fontWeight: "bold",
            color: "#F58020", // Color del texto seleccionado
          },
        },
      }}
      muiTableHeadProps={{
        sx: { display: "table-header-group" },
      }}
      muiTableBodyCellProps={({ row, cell }) => {
        return {
          sx: {
            color: "#FFFFFF",
            opacity: "0.7",
            fontWeight: "normal",
            fontSize: 12,
          },
        };
      }}
      muiTableHeadCellProps={{
        sx: { color: "#FFFFFF", fontSize: 12 },
      }}
      icons={{
        SearchIcon: () => <Icon color="primary">search</Icon>,
        SearchOffIcon: () => <Icon color="primary">search_off</Icon>,
        CloseIcon: () => <Icon color="primary">close</Icon>,
        FullscreenIcon: () => <Icon color="primary">fullscreen</Icon>,
        FullscreenExitIcon: () => <Icon color="primary">fullscreen_exit</Icon>,
        FilterAltIcon: () => <Icon color="primary">search</Icon>,
        FilterListIcon: () => <Icon color="primary">filter_list</Icon>,
        FilterListOffIcon: () => <Icon color="primary">filter_list_off</Icon>,
        DensitySmallIcon: () => <Icon color="primary">density_small</Icon>,
        DensityMediumIcon: () => <Icon color="primary">density_medium</Icon>,
        DensityLargeIcon: () => <Icon color="primary">density_large</Icon>,
        FirstPageIcon: () => <Icon color="primary">first_page</Icon>,
        LastPageIcon: () => <Icon color="primary">last_page</Icon>,
        ChevronLeftIcon: () => <Icon color="primary">navigate_before</Icon>,
        ChevronRightIcon: () => <Icon color="primary">navigate_next</Icon>,
        MoreVertIcon: () => <Icon color="primary">more_vert</Icon>,
        MoreHorizIcon: () => <Icon color="primary">more_horiz</Icon>,
        SortIcon: () => <Icon color="primary">sort</Icon>,
        ClearAllIcon: () => <Icon color="primary">clear_all</Icon>,
        VisibilityOffIcon: () => <Icon color="primary">visibility_off</Icon>,
        ViewColumnIcon: () => <Icon color="primary">view_column</Icon>,
        SyncAltIcon: () => <Icon color="primary">import_export</Icon>,
        ArrowDownwardIcon: (props) => {
          var icon = <Icon color="primary">arrow_downward</Icon>;
          props.className ===
          "MuiTableSortLabel-icon MuiTableSortLabel-iconDirectionAsc css-1hi7cb7-MuiTableSortLabel-icon"
            ? (icon = <Icon color="primary">arrow_upward</Icon>)
            : (icon = <Icon color="primary">arrow_downward</Icon>);

          return icon;
        },
        ArrowRightIcon: () => <Icon color="primary">import_export</Icon>,
        ArrowDownwardIcon: () => <Icon color="primary">import_export</Icon>,
      }}
      enableExpanding={false}
      renderDetailPanel={
        !tablaProx
          ? ({ row }) => {
              return (
                <Box>
                  {row.original?.loading ? (
                    <Loading title={"Cargando documentos, por favor espere."} />
                  ) : (
                    <>
                      {(Array.isArray(row.original?.documentos) &&
                        row.original?.documentos?.length === 0) ||
                      row.original?.documentos?.length === undefined ? (
                        <Grid container spacing={3}>
                          <Grid item xs={12} md={12} lg={6}>
                            <MDBox textAlign="right">
                              <MDTypography variant="text" color="warning" fontSize="12px">
                                No hay documentos cargados
                              </MDTypography>
                            </MDBox>
                          </Grid>
                          <Grid item xs={12} md={12} lg={6}>
                            <MDBox textAlign="left">
                              <Button
                                variant="contained"
                                startIcon={<Icon>add</Icon>}
                                onClick={() => {
                                  onCargarDoc(row.original);
                                }}
                                size="small"
                                color="primary"
                              >
                                Cargar valoración
                              </Button>
                            </MDBox>
                          </Grid>
                        </Grid>
                      ) : (
                        <>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6} lg={2}>
                              <MDBox textAlign="left">
                                <MDTypography variant="text" color="warning" fontSize="12px">
                                  Titulo del documento
                                </MDTypography>
                              </MDBox>
                            </Grid>
                            <Grid item xs={12} md={6} lg={2}>
                              <MDBox textAlign="left">
                                <MDTypography variant="text" color="warning" fontSize="12px">
                                  Fecha de carga
                                </MDTypography>
                              </MDBox>
                            </Grid>
                            <Grid item xs={12} md={6} lg={2}>
                              <MDBox textAlign="left">
                                <MDTypography variant="text" color="warning" fontSize="12px">
                                  Observaciones
                                </MDTypography>
                              </MDBox>
                            </Grid>
                            <Grid item xs={12} md={6} lg={3}>
                              <MDBox textAlign="right">
                                <Button
                                  variant="contained"
                                  startIcon={<Icon>add</Icon>}
                                  onClick={() => {
                                    onCargarDoc(row.original);
                                  }}
                                  size="small"
                                  color="primary"
                                >
                                  Cargar valoración
                                </Button>
                              </MDBox>
                            </Grid>
                          </Grid>

                          {_.map(row.original?.documentos, (item) => (
                            <Grid container spacing={3} key={item.idDocumentoCita}>
                              <Grid item xs={12} md={6} lg={2}>
                                <MDBox textAlign="left">
                                  <MDTypography variant="text" color="white" fontSize="12px">
                                    {item.tituloDocumento}
                                  </MDTypography>
                                </MDBox>
                              </Grid>
                              <Grid item xs={12} md={6} lg={2}>
                                <MDBox textAlign="left">
                                  <MDTypography variant="text" color="white" fontSize="12px">
                                    {moment.utc(item.fechaCarga).isAfter(moment("2025-09-04"))
                                      ? moment
                                          .utc(item.fechaCarga)
                                          .tz("America/Mexico_City")
                                          .format("DD/MM/YYYY HH:mm:ss")
                                      : moment.utc(item.fechaCarga).format("DD/MM/YYYY HH:mm:ss")}
                                  </MDTypography>
                                </MDBox>
                              </Grid>
                              <Grid item xs={12} md={6} lg={2}>
                                <MDBox textAlign="left">
                                  <MDTypography variant="text" color="white" fontSize="12px">
                                    {item.observaciones}
                                  </MDTypography>
                                </MDBox>
                              </Grid>
                              <Grid item xs={12} md={6} lg={3}>
                                <MDBox textAlign="left">
                                  <MDTypography variant="text" color="white" fontSize="12px">
                                    {descargandoId === item.idDocumentoCita ? (
                                      <DescargarArchivo progress={progress} />
                                    ) : (
                                      <Button
                                        key={item.idDocumentoCita}
                                        variant="contained"
                                        startIcon={<Icon>arrow_downward_icon</Icon>}
                                        onClick={() => {
                                          DownloadArchivo(item.rutaDescarga, item.idDocumentoCita);
                                        }}
                                        size="small"
                                        style={{ textTransform: "inherit", background: "#605CA9" }}
                                      >
                                        Descargar
                                      </Button>
                                    )}
                                  </MDTypography>
                                </MDBox>
                              </Grid>
                            </Grid>
                          ))}
                        </>
                      )}
                    </>
                  )}
                </Box>
              );
            }
          : undefined
      }
      muiExpandButtonProps={({ row, table }) => ({
        children: row.getIsExpanded() ? (
          <Icon sx={{ background: "#5873B8", borderRadius: "50%" }}>keyboard_arrow_right_icon</Icon>
        ) : (
          <Icon
            sx={{ background: "#5873B8", borderRadius: "50%" }}
            onClick={() => {
              dispatch(ObtenerDocumentosCita(row.original.idCita, false));
            }}
          >
            keyboard_arrow_down_icon
          </Icon>
        ),
      })}
      enableRowActions={tablaProx}
      renderRowActionMenuItems={({ row, table, closeMenu }) => {
        const { fechaCita, horaCita, minutoCita } = row.original;

        // Combinar fecha + hora + minuto en un objeto moment
        const citaDate = moment(fechaCita).set({
          hour: horaCita,
          minute: minutoCita,
          second: 0,
          millisecond: 0,
        });

        const ahora = moment();

        // Calcular diferencia en horas
        const horasRestantes = citaDate.diff(ahora, "hours", true); // true para decimales
        var opciones = [];
        if (notificarpacientemedico.length > 0) {
          opciones.push(
            <MRT_ActionMenuItem //or just use a normal MUI MenuItem component
              icon={<Icon color="info">notifications</Icon>}
              key="notiPac"
              label="Notificar paciente"
              onClick={() => {
                NotificarPaciente(row.original);
                closeMenu();
              }}
              table={table}
            />
          );
          opciones.push(
            <MRT_ActionMenuItem //or just use a normal MUI MenuItem component
              icon={<Icon color="info">notifications</Icon>}
              key="notiMed"
              label="Notificar médico"
              onClick={() => {
                NotificarMedico(row.original);
                closeMenu();
              }}
              table={table}
            />
          );
        }
        if (agregareliminarCita.length > 0) {
          if (horasRestantes > 3) {
            opciones.push(
              <MRT_ActionMenuItem //or just use a normal MUI MenuItem component
                icon={<Icon color="error">delete</Icon>}
                key="delete"
                label="Eliminar cita"
                onClick={() => {
                  EliminarCita(row.original);
                  closeMenu();
                }}
                table={table}
              />
            );
          }
        }
        return opciones;
      }}
      renderTopToolbarCustomActions={({ table }) => {
        return (
          <Box
            sx={{
              display: "flex",
              gap: "16px",
              padding: "8px",
              flexWrap: "wrap",
            }}
          >
            <MDTypography variant="h6" color="white">
              {tablaProx ? "CITAS PRÓXIMAS" : "CITAS ANTERIORES"}
            </MDTypography>
          </Box>
        );
      }}
      muiTableBodyRowProps={({ row }) => ({
        //onDoubleClick: () => VerSolicitud(row.original),
        style: { cursor: "pointer" },
      })}
    />
  );
};

export default Example;
